import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import EventNoteIcon from '@mui/icons-material/EventNote';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import {useLocation, useNavigate, useOutlet} from 'react-router-dom';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

import Logo from '../assets/logo.png';
import {SwipeableDrawer} from "@mui/material";
import Drawer from "@mui/material/Drawer";

import {AnimatePresence, motion} from 'framer-motion';

const drawerWidth = 240;

function Sidebar() {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [isClosing, setIsClosing] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const currentOutlet = useOutlet();

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    const handleNavigation = (path) => {
        navigate(path);
        if (mobileOpen) {
            setMobileOpen(false);
        }
    }

    const drawer = (
        <Box sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Toolbar/>
            <Divider/>
            <List disablePadding>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('/')}>
                        <ListItemIcon>
                            <DashboardIcon/>
                        </ListItemIcon>
                        <ListItemText primary={"Dashboard"}/>
                    </ListItemButton>
                </ListItem>
                {/* ... tes autres items de menu ... */}
                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('/bookings')}>
                        <ListItemIcon>
                            <EventNoteIcon/>
                        </ListItemIcon>
                        <ListItemText primary={"Réservations"}/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('/estimates')}>
                        <ListItemIcon>
                            <DescriptionIcon/>
                        </ListItemIcon>
                        <ListItemText primary={"Devis"}/>
                    </ListItemButton>
                </ListItem>
                {/*<ListItem disablePadding>*/}
                {/*    <ListItemButton onClick={() => handleNavigation('/invoices')}>*/}
                {/*        <ListItemIcon>*/}
                {/*            <RequestQuoteIcon/>*/}
                {/*        </ListItemIcon>*/}
                {/*        <ListItemText primary={"Factures"}/>*/}
                {/*    </ListItemButton>*/}
                {/*</ListItem>*/}
                {/*<ListItem disablePadding>*/}
                {/*    <ListItemButton onClick={() => handleNavigation('/payments')}>*/}
                {/*        <ListItemIcon>*/}
                {/*            <AttachMoneyIcon/>*/}
                {/*        </ListItemIcon>*/}
                {/*        <ListItemText primary={"Paiements"}/>*/}
                {/*    </ListItemButton>*/}
                {/*</ListItem>*/}
                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('/clients')}>
                        <ListItemIcon>
                            <PeopleIcon/>
                        </ListItemIcon>
                        <ListItemText primary={"Clients"}/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('/products')}>
                        <ListItemIcon>
                            <Inventory2Icon/>
                        </ListItemIcon>
                        <ListItemText primary={"Produits"}/>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={() => handleNavigation('/options')}>
                        <ListItemIcon>
                            <PlaylistAddIcon/>
                        </ListItemIcon>
                        <ListItemText primary={"Options"}/>
                    </ListItemButton>
                </ListItem>
            </List>
            <Divider/>
            <Box sx={{mt: 'auto'}}>
                <Divider/>
                <List disablePadding>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => handleNavigation('/settings')}>
                            <ListItemIcon>
                                <SettingsIcon/>
                            </ListItemIcon>
                            <ListItemText primary={"Paramètres"}/>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => handleNavigation('/account')}>
                            <ListItemIcon>
                                <AccountCircleIcon/>
                            </ListItemIcon>
                            <ListItemText primary={"Compte"}/>
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
        </Box>
    );

    return (
        <Box sx={{display: 'flex'}}>
            <AppBar
                position="fixed"
                sx={{
                    width: {xs: '100%', sm: '100%'},
                    zIndex: 1201,
                    overflowX: 'hidden'
                }}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{mr: 2, display: {sm: 'none'}}}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <img src={Logo} alt="Logo" style={{height: '40px', cursor: 'pointer'}}
                         onClick={() => navigate('/')}/>
                </Toolbar>
            </AppBar>
            <Box
                component="nav"
                sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
            >
                <SwipeableDrawer
                    variant="temporary"
                    open={mobileOpen}
                    onTransitionEnd={handleDrawerTransitionEnd}
                    onClose={handleDrawerClose}
                    onOpen={handleDrawerToggle}
                    swipeAreaWidth={60}
                    sx={{
                        display: {xs: 'block', sm: 'none'},
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                    slotProps={{
                        root: {
                            keepMounted: true,
                        },
                    }}
                    disableSwipeToOpen={false}
                    disableDiscovery={false}
                >
                    {drawer}
                </SwipeableDrawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: {xs: 'none', sm: 'block'},
                        '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    width: {sm: `calc(100% - ${drawerWidth}px)`},
                    overflowX: 'hidden'
                }}
            >
                <Toolbar/>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={location.pathname}
                        initial={{opacity: 0, y: 10}}
                        animate={{opacity: 1, y: 0}}
                        exit={{opacity: 0, y: -10}}
                        transition={{duration: 0.2}}
                        style={{width: '100%'}}
                    >
                        {currentOutlet}
                    </motion.div>
                </AnimatePresence>
            </Box>
        </Box>
    );
}

export default Sidebar;